import { CustomerComplaintCount } from './customer-complaint-counts';

export interface CustomerComplaintCountsState {
  complaintCounts: CustomerComplaintCount[];
  isLoading: boolean;
}

export const initialCustomerComplaintCountsState: CustomerComplaintCountsState = {
  complaintCounts: [],
  isLoading: false
};
